import { Component, OnInit } from '@angular/core';
import { SkillSet } from '../../skill-repo-employee-tiles/skill-repo-employee-tiles.component';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';

export interface profileinfo {
  firstName: string,
  lastName: string,
  grade: string,
  experience: number,
  isDeleted: string,
  location: string,
  swotInfo: string,
  employeeId: number,
  domains: string,
  resume: string,
  competencies: string,
  smeFactory: string
}


@Component({
  selector: 'app-profile-view1',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.css']
})



export class ProfileViewdemoComponent implements OnInit {
  skillSets: SkillSet[] = [
    { color: 1, name: 'Microsoft' },
    { color: 1, name: '.Net' },
    { color: 1, name: 'Web API' },
    { color: 1, name: 'Sharepoint' },
    { color: 2, name: 'SSRS' },
    { color: 2, name: 'Mongo DB' },
    { color: 3, name: 'Tabluse' },

  ];
  data: any;
  employeeId: number;
  surname: any;
  myArray: any[] = [];
  competencyName: any[] = [];
  domains: string[];
  smeFactory: any;
  certifications: string[];
  smeNames: any;
  primarySkills: any;
  skills: any;
  skillList = [];
  exp: number = 0;


  constructor(private employeeService: EmployeeService, private toastr: ToastrService, private shareSkillService: SharedSkillService, private auth: AuthServiceService, private router: Router) { }

  ngOnInit() {
    const empId = localStorage.getItem('Id');
    this.employeeId = parseInt(empId);

    //this.getEmployeeInfo();



  }

  getEmployeeInfo() {
    this.skillList = [];
    this.employeeService.getEmployeeDetails(this.employeeId).subscribe(res => {
      if (res.data) {
        this.data = res.data;
        this.exp = this.data.experience;
        if (this.exp >= 1) {
          this.exp = Math.floor(this.exp);
        }
        this.competencyName = this.data.competencies;
        this.domains = this.data.domains;
        let subCompetencies = this.data.competencies.map(i => i.subCompetencies);
        subCompetencies.map(s => {
          s.map(j => {
            j.primarySkills.map(k => {
              this.skillList.push(k)

            })
          })
        })
        this.certifications = this.data.competencies[0].subCompetencies[0].certificates;
      }
      else {
        this.toastr.warning("No Data of employee");
        this.certifications = [];
      }
    });
  }


  getPrimaryDefaultSkills(primarySkills) {
    return this.primarySkills && this.primarySkills.length ? this.primarySkills.map(pri => pri.skill).join(', ') : null
  }

  naviagateToEmployeeDetails() {
    this.shareSkillService.setEmployeeId(this.employeeId)
    this.shareSkillService.setMode(false)
    this.router.navigate(["Home/Employee-details"])
  }
}


